import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type CountSessionFragment } from "~/gql/queries/count/countSession.generated";

interface CountSessionsState {
	selectedSession: CountSessionFragment | null;
}

const initialState: CountSessionsState = {
	selectedSession: null
};

export const countSessionsSlice = createSlice({
	initialState,
	name: "countSessions",
	reducers: {
		clearSelectedSession: (state) => {
			state.selectedSession = null;
		},
		setSelectedSession: (state, action: PayloadAction<CountSessionFragment | null>) => {
			state.selectedSession = action.payload;
		}
	}
});

export const { clearSelectedSession, setSelectedSession } = countSessionsSlice.actions;

export default countSessionsSlice.reducer;
